import { motion } from 'framer-motion';

export function FeatureCard({ children, delay = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      whileHover={{ 
        scale: 1.02,
        transition: { duration: 0.2, ease: [0.22, 1, 0.36, 1] }
      }}
      transition={{ 
        duration: 0.5, 
        delay,
        ease: [0.22, 1, 0.36, 1]
      }}
      className="group relative flex items-start gap-3 px-4 py-4 rounded-2xl item-border border-white/10 bg-gradient-to-br from-white/5 to-transparent backdrop-blur-sm transition-all hover:border-white/20 hover:shadow-lg hover:shadow-primary/5"
    >
      {children}
    </motion.div>
  );
}
